import { z } from 'zod';
export const ACCOUNT_ACTIONS = ['account.deleted', 'account.restored', 'account.purged'];
export const AccountDetailsSchemas = {
    'account.deleted': z.object({ workspaceIds: z.array(z.string()), connectionsRevoked: z.number().int(), purgeAfter: z.string() }).strict(),
    'account.restored': z.object({ deletedAt: z.string(), workspaceIds: z.array(z.string()), reason: z.string() }).strict(),
    'account.purged': z.object({ deletedAt: z.string(), workspaceIds: z.array(z.string()), authUserDeleted: z.literal(true), reason: z.string().optional() }).strict()
};
export const ACCOUNT_DETAILS_VERSION = { 'account.deleted': 1, 'account.restored': 1, 'account.purged': 1 };
export const ACCOUNT_DETAILS_MIGRATIONS = { 'account.deleted': {}, 'account.restored': {}, 'account.purged': {} };
export const ACCOUNT_SCRUB = {
    'account.deleted': { fields: { workspaceIds: 'pseudonym', connectionsRevoked: 'keep', purgeAfter: 'keep' } },
    'account.restored': { fields: { deletedAt: 'keep', workspaceIds: 'pseudonym' } },
    'account.purged': { fields: { deletedAt: 'keep', workspaceIds: 'pseudonym', authUserDeleted: 'keep' } }
};
//# sourceMappingURL=account-events.js.map